import { createSelector } from "@ngrx/store";

import { CoreContentState } from "../state";

import { Flag, FlagState } from "./flag.model";

/**
 * @deprecated [fabric-deprecated] - Use fabric FlagService from svc-content instead
 */
export namespace FlagSelector {
	export const getState = (state: CoreContentState): FlagState => state.flag;

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getAllFlags_v2)" instead
	 */
	export const getAll = (state: CoreContentState): Flag[] => state.flag.flags;

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getAllFlags_v2)" instead
	 */
	export const getInitialFlags = (state: CoreContentState): Flag[] => state.flag.initialFlags;

	export const getById = (id: string) =>
		createSelector(getAll, (flags): Flag | undefined => flags.find((flag) => flag.id === id));

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getCurrentFlag_v2)" instead
	 */
	export const getCurrentFlag = (state: CoreContentState): Flag | undefined => state.flag.currentFlag;

	export const isBusy = (state: CoreContentState): boolean => state.flag.isBusy;
}
